import { AWSService } from '@amzn/awscat-pattern-library-service-model';
import { awsServiceDisplayNames } from './DisplayNames';

export const getTopServicesText = (services: Array<AWSService | string>) => {
  return services
    .map((service) =>
      Object.values(AWSService).includes(service as AWSService)
        ? awsServiceDisplayNames.get(service as AWSService)
        : service,
    )
    .join(', ');
};
